import React from 'react';

const Spinner = () => {
  return (
    <div className="flex justify-center items-center h-full w-full p-8">
      <div className="w-12 h-12 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default Spinner;
